import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { registrationService, PublicRegistrationListItem } from '../services/registration-service';

export function RegisterPage() {
  const navigate = useNavigate();
  const [divisions, setDivisions] = useState<PublicRegistrationListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    registrationService.getPublicRegistrationDivisions()
      .then((result) => {
        if (!cancelled) setDivisions(result);
      })
      .catch((err) => {
        console.error('Failed to load public registration divisions:', err);
        if (!cancelled) setError('Failed to load available divisions. Please try again.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-secondary-900 dark:text-white mb-4">Register / Update Access</h1>
        <p className="text-secondary-600 dark:text-secondary-400 mb-6">
          Select your division below to register for an account or add access to another workflow.
        </p>

        {loading && (
          <p className="text-secondary-500 dark:text-secondary-400 text-sm">Loading divisions...</p>
        )}

        {error && (
          <p role="alert" className="text-red-600 dark:text-red-400 text-sm mb-4">{error}</p>
        )}

        {!loading && !error && divisions.length === 0 && (
          <p className="text-secondary-600 dark:text-secondary-400 text-sm">
            Public registration is not currently configured for any division. Please contact your administrator.
          </p>
        )}

        {divisions.length > 0 && (
          <div className="space-y-3">
            {divisions.map((division) => (
              <Link key={division.divisionId} to={`/register/${division.slug}`} className="block">
                <Button className="w-full" variant="outline">
                  {division.divisionName}
                </Button>
              </Link>
            ))}
          </div>
        )}

        <Button onClick={() => navigate('/')} variant="secondary" className="w-full mt-6">
          Return to Home
        </Button>
      </div>
    </div>
  );
}
